import { render, staticRenderFns } from "./my-act.vue?vue&type=template&id=177cbffa&scoped=true"
import script from "./my-act.vue?vue&type=script&lang=js"
export * from "./my-act.vue?vue&type=script&lang=js"
import style0 from "./my-act.vue?vue&type=style&index=0&id=177cbffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177cbffa",
  null
  
)

export default component.exports